module.exports = __webpack_public_path__ + "static/img/pop_illustration_social.e2d8629.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pop_illustration_social.png
// module id = 320
// module chunks = 9